import { jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import { InternalSideSheetContext } from './content.es.js';

const InternalSideSheetContextProvider = ({ children, variant = 'default', hideBack = false, onClose = ()=>{}, onBack = ()=>{} })=>{
    const [hasHeaderShadow, setHasHeaderShadow] = useState(false);
    const [hasFooterShadow, setHasFooterShadow] = useState(false);
    return jsx(InternalSideSheetContext.Provider, {
        value: {
            hideBack,
            variant,
            onClose,
            onBack,
            hasHeaderShadow,
            setHasHeaderShadow,
            hasFooterShadow,
            setHasFooterShadow
        },
        children: children
    });
};

export { InternalSideSheetContextProvider };
//# sourceMappingURL=provider.es.js.map
